import { UserSignupMethods } from '@authentic/loyalty-pwa/interfaces';
import { GoogleOAuthService, FacebookOAuthService, AppleOAuthService } from '@authentic/loyalty-pwa/services';

export const googleOAuth = new GoogleOAuthService({
    client_id: process.env.GOOGLE_CLIENT_ID as string,
    redirect_uri: process.env.OAUTH_REDIRECT_URI as string
})

export const facebookOAuth = new FacebookOAuthService({
    client_id: process.env.FACEBOOK_CLIENT_ID as string,
    redirect_uri: process.env.OAUTH_REDIRECT_URI as string
})

export const appleOAuth = new AppleOAuthService({
    client_id: process.env.APPLE_CLIENT_ID as string,    
    redirect_uri: process.env.OAUTH_REDIRECT_URI as string
})

export const oauthServices = {
    [UserSignupMethods.GOOGLE]: googleOAuth,
    [UserSignupMethods.FACEBOOK]: facebookOAuth,
    [UserSignupMethods.APPLE]: appleOAuth,
}